import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-circle-top",
  templateUrl: "./med-icon-arrow-circle-top.component.html",
})
export class MedIconArrowCircleTopComponent extends SvgMixinComponent {}
